import { Component, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from '../services/notification.service';
import { SupportService } from '../support.service';
import { CurrentUserService } from '../user/user.service';
import { CreateComponent } from './create/create.component';
import { MarkupService } from './markup.service';
import { Markup } from './model/markup.model';

@Component({
  selector: 'app-markup-table',
  templateUrl: './markup-table.component.html',
  styleUrls: ['./markup-table.component.scss']
})
export class MarkupTableComponent implements OnDestroy {
  constructor(
    private dialog: MatDialog,
    private markupService: MarkupService,
    public supportService: SupportService,
    private currentUserService: CurrentUserService,
    private fb: FormBuilder,
    private notificationService: NotificationService
  ) {
    this.load();
  }

  loading: boolean = false;

  createEvent = this.markupService.createEvent.subscribe(() => {
    this.load();
  });

  updateEvent = this.markupService.updatedEvent.subscribe(() => {
    this.load();
  });

  deleteEvent = this.markupService.deleteEvent.subscribe(() => {
    this.load();
  });

  dataSource: Markup[] = [];

  loadPrice = false;

  get isAdmin() {
    return Boolean(
      this.currentUserService.user?.roles?.some((role) => role.description === 'admin')
    );
  }

  searchForm = this.fb.group({
    order: this.fb.control<'ASC' | 'DESC' | undefined>('ASC'),
    orderBy: this.fb.control<keyof Markup | null>('id')
  });

  async sortData(event: Sort) {
    const order: { direction: 'ASC' | 'DESC' | undefined; active: keyof Markup | null } = {
      direction: event.direction
        ? (event.direction.toUpperCase() as 'ASC' | 'DESC')
        : undefined,
      active: (event.active || null) as keyof Markup | null
    };
    this.searchForm.controls.order.setValue(order.direction);
    this.searchForm.controls.orderBy.setValue(order.active);
    this.load();
  }

  async updatePrices() {
    if (!this.isAdmin) return;
    this.loadPrice = true;
    try {
      await firstValueFrom(this.markupService.updatePrice());
      this.notificationService.notice('Цены обновлены!');
    } finally {
      this.loadPrice = false;
    }
  }

  async load() {
    this.loading = true;
    try {
      this.dataSource = await firstValueFrom(this.markupService.search(this.searchForm.value));
    } finally {
      this.loading = false;
    }
  }

  async remove(item: Markup) {
    if (!this.isAdmin) return;
    this.loading = true;
    try {
      await firstValueFrom(this.markupService.delete(item.id));
    } finally {
      this.loading = false;
    }
  }

  add() {
    if (!this.isAdmin) return;
    const dialog = this.dialog.open(CreateComponent, {
      width: '960px',
      maxWidth: '94vw',
      autoFocus: false
    });
    const subs = dialog.componentInstance.doneEvent.subscribe(() => {
      subs.unsubscribe();
      dialog.close();
    });
  }

  ngOnDestroy() {
    this.createEvent.unsubscribe();
    this.deleteEvent.unsubscribe();
    this.updateEvent.unsubscribe();
  }

  update(markup: Markup) {
    if (!this.isAdmin) return;
    const dialog = this.dialog.open(CreateComponent, {
      width: '960px',
      maxWidth: '94vw',
      autoFocus: false
    });
    dialog.componentInstance.markup = markup;
    const subs = dialog.componentInstance.doneEvent.subscribe(() => {
      subs.unsubscribe();
      dialog.close();
    });
  }
}
